import clsx from 'clsx';

import type { FC, HTMLAttributes } from 'react';

import s from './Spinner.module.css';

type SpinnerProps = HTMLAttributes<HTMLDivElement> & {
  spinnerProps?: HTMLAttributes<HTMLDivElement>;
};

const Spinner: FC<SpinnerProps> = ({ className: wrapperClassName, spinnerProps, ...props }) => (
  <div className={clsx(s.loaderWrapper, wrapperClassName)} {...props}>
    <div {...spinnerProps} className={clsx(s.loader, spinnerProps?.className)} />
  </div>
);

export { Spinner };
